<template>
  <div class="about text-left">
    <div class="text-container title-container">
      <h2>Sobre o Programa de Educação e Prevenção de Acidentes</h2>
      
      <br/>

      <h4>Mais de 1 milhão de crianças já estiveram em nossos auditórios aprendendo sobre prevenção de acidentes.</h4>

      <br/>
      <br/>

      <p>A Rede SARAH de Hospitais de Reabilitação é uma instituição pública, composta por 9 unidades sediadas em 8 capitais brasileiras. Muitos dos nossos pacientes foram vítimas de traumas decorrentes de acidentes de trânsito, quedas, acidentes por mergulho, entre outras causas. </p>
      <p>O Programa de Educação e Prevenção de Acidentes foi criado a partir do compromisso contratual, firmado com a sociedade brasileira, de atuar na prevenção da ocorrência das principais patologias atendidas. Temos como objetivo minimizar as consequências destes eventos ou mesmo evitar que ocorram. Por esse motivo, estamos sempre mobilizados no sentido de divulgar informações que possam contribuir para a redução da ocorrência e da gravidade desses acidentes. </p>
      <p>Por cerca de duas décadas, o Programa ministrou, em diversas unidades da Rede, palestras presenciais para um milhão de crianças e adolescentes, encaminhadas por escolas públicas e privadas acompanhadas por seus professores. Agora, extrapolamos o alcance deste trabalho com a produção da versão <i>on line</i>. </p>
      <p>Nosso conteúdo foi elaborado a partir da experiência acumulada durante anos. Explicamos detalhadamente as consequências de práticas inadequadas no trânsito e no lazer e procuramos extrapolar os limites da dinâmica dos acidentes em si, mostrando como é o funcionamento do corpo humano e apontando para sua fragilidade diante das forças envolvidas. </p>
      <p>São videos educativos, com duração máxima de 9 minutos cada <span class="cursor-pointer text-blue" @click="$router.push({ name: 'Conteudos' })">(veja aqui)</span>, que podem ser assistidos individualmente ou em sequência. A linguagem utilizada é compatível, prioritariamente, a crianças e adolescentes na faixa etária de 8 a 14 anos. </p>
      <p>Os vídeos foram elaborados para serem vistos na escola ou em casa com toda a família. Mostramos como é a Rede SARAH, falamos sobre nossos pacientes e abordamos questões sobre o sistema nervoso central e sobre condutas a serem seguidas visando a prevenção de acidentes e/ou a diminuição da gravidade de suas consequências. </p>
      <p>Não deixe de compartilhar, faça esse conteúdo chegar ao maior número de pessoas possível. </p>
      <p>Seja você também uma agente de prevenção.</p>

      <br/>
      <br/>

      <h3>Prevenção é educação para toda vida! </h3>

      <br/>
      <br/>

    </div>

    <img class="hidden md:block" alt="Garoto dando sinal de vida na faixa de pedestres" src="../assets/cuidados/sinal_faixa.png" style="position: absolute; right: 100px; top: 90px; width: 630px; max-width: 50%;">
  </div>
</template>

<style scoped>
p {
  margin-top: 1rem;
}

.text-container {
  width: 100%;
}

@media (min-width: 768px) {
  .text-container {
    width: 60%;
  }
}
</style>